@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.navigation.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/waifupics.modules.features.navigation.generated.resources/"

@delegate:ResourceContentHash(640_047_400)
internal val Res.drawable.about_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:about_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/about_menu_icon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-333_528_974)
internal val Res.drawable.gallery_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:gallery_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/gallery_menu_icon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_280_031_119)
internal val Res.drawable.home_menu_icon: DrawableResource by lazy {
      DrawableResource("drawable:home_menu_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/home_menu_icon.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("about_menu_icon", Res.drawable.about_menu_icon)
  map.put("gallery_menu_icon", Res.drawable.gallery_menu_icon)
  map.put("home_menu_icon", Res.drawable.home_menu_icon)
}
